export function quotesConverter(text) {
  const complerePhrase = text.subText
  const regex = /(?=[-])/g
  const arrayPhrase = complerePhrase.split(regex)
  return arrayPhrase
}
